import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link as DomLink } from "react-router-dom";
import { Mobile, Default } from "../../utils/deviceHelpers";
import placeHolder from "../../assets/images/placeHolder.png";
import { api, storage } from "../../utils";
import { functions } from "../../utils";
import _ from "lodash";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import formatting from "../../utils/formatHelpers";

export default function SitewideSearch(props) {
  const { SearchTerm } = useParams();
  const [resultsLoaded, setResultsLoaded] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const category = props.Category;

  function LoadingIndicator() {
    return (
      <div id="ghost-element">
        <Mobile>
          <Grid container>
            <Grid item xs={12}>
              <Stack spacing={1}>
                <Skeleton variant="rectangular" width={210} height={118} />
                <Skeleton variant="text" />
              </Stack>
            </Grid>
          </Grid>
        </Mobile>
        <Default>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{ marginTop: "3rem" }}
          >
            <Stack spacing={1}>
              <Skeleton variant="rectangular" width={210} height={118} />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
            </Stack>
            <Stack spacing={1}>
              <Skeleton variant="rectangular" width={210} height={118} />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
            </Stack>
            <Stack spacing={1}>
              <Skeleton variant="rectangular" width={210} height={118} />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
            </Stack>
            <Stack spacing={1}>
              <Skeleton variant="rectangular" width={210} height={118} />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
            </Stack>
          </Stack>
        </Default>
      </div>
    );
  }

  function storeRecentlyViewed(style) {
    const previous = JSON.parse(
      storage.getSessionStorageItem("hsRecentlyViewedProducts")
    );
    if (previous !== null) {
      const viewedArray = _.uniqBy(_.concat(previous, style), (d) => d.style);
      storage.setSessionStorageItem(
        "hsRecentlyViewedProducts",
        JSON.stringify(viewedArray)
      );
    } else if (previous === null) {
      storage.setSessionStorageItem(
        "hsRecentlyViewedProducts",
        JSON.stringify([style])
      );
    }
  }

  useEffect(() => {
    api.fetch(`search?q=${SearchTerm}`).then((response) => {
      const filteredResults = _.filter(
        response.data.results,
        function (result) {
          return result.style;
        }
      );
      setSearchResults(filteredResults);
      setResultsLoaded(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SearchTerm]);

  return (
    <>
      {!resultsLoaded ? (
        <LoadingIndicator />
      ) : (
        <Stack>
          <Typography variant="h1">
            Search Results for "{SearchTerm}"
          </Typography>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                sm: "repeat(1, 1fr)",
                md: "repeat(4, 1fr)",
                lg: "repeat(4, 1fr)",
                xl: "repeat(4, 1fr)",
              },
            }}
          >
            {searchResults && searchResults.length > 0 ? (
              searchResults.map((result) => (
                <div
                  className="all-tiles"
                  key={result.title}
                  onClick={() => storeRecentlyViewed(result.style)}
                >
                  {result.style && (
                    <DomLink
                      to={{
                        pathname: `/product/${result.title}`,
                        state: {
                          isMill:
                            category === "Solder" ||
                            category === "Wire" ||
                            category === "Tubing"
                              ? true
                              : false,
                          showBAR:
                            category === "All Settings" ||
                            category === "All Shanks"
                              ? true
                              : false,
                          productGroup: category,
                          mtoConfiguratorProduct:
                            result.style.mtoConfiguratorProduct,
                          recentlyViewed: JSON.parse(
                            storage.getSessionStorageItem(
                              "hsRecentlyViewedProducts"
                            )
                          ),
                        },
                      }}
                    >
                      {result.style.images.length === 0 ? (
                        <img
                          className="mainImg"
                          readOnly={true}
                          src={placeHolder}
                          alt=""
                          onError={(e) => {
                            e.target.src = placeHolder;
                          }}
                        />
                      ) : (
                        <img
                          className="mainImg"
                          readOnly={true}
                          src={result.style.images[0]}
                          alt=""
                          onError={(e) => {
                            e.target.src = placeHolder;
                          }}
                        />
                      )}
                      <br />
                      <Stack>
                        <Typography
                          className="style-text"
                          variant="body2"
                          sx={{ fontSize: "1.6rem", fontWeight: "800" }}
                        >
                          {result.style.style}
                        </Typography>
                        <Typography className="style-text">
                          {formatting["decodeHtml"](result.style.description)}
                        </Typography>
                        <Stack className="icon-div" spacing={1} direction="row">
                          {result.style.icons.length === 0 ? (
                            <Typography className="icons" />
                          ) : (
                            result.style.icons.map((icons, key) => {
                              return (
                                <Typography key={icons} className="icons">
                                  {functions.getIcons(icons)}
                                </Typography>
                              );
                            })
                          )}
                        </Stack>
                      </Stack>
                    </DomLink>
                  )}
                </div>
              ))
            ) : (
              <Typography sx={{ margin: "2rem" }}>
                No Results Found - Try Another Search
              </Typography>
            )}
          </Box>
        </Stack>
      )}
    </>
  );
}
